import React from 'react'
import PropTypes from 'prop-types'
import { getJSONFromScript } from 'lib/server_params'

class PayPalHeader extends React.Component {
  static propTypes = {
    element: PropTypes.string,
  }

  render() {
    const navigation = getJSONFromScript('navigation')
    return (
      <div
        dangerouslySetInnerHTML={{ __html: navigation[this.props.element] }}
      />
    )
  }
}

export default PayPalHeader
